
import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { safeLocalStorage } from "@/lib/utils";

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consentValue = safeLocalStorage("cookie-consent");
    // Show the banner if no choice has been made yet
    setShowConsent(consentValue === null);
  }, []);

  const handleAccept = () => {
    safeLocalStorage("cookie-consent", "accepted");
    setShowConsent(false);
  };

  const handleDecline = () => {
    safeLocalStorage("cookie-consent", "declined");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 bg-background/95 backdrop-blur-sm border-t border-border shadow-lg">
      <div className="container max-w-screen-xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="pr-8">
            <h3 className="text-lg font-medium mb-1">Cookie Consent</h3>
            <p className="text-sm text-muted-foreground">
              This website uses cookies to enhance your browsing experience and provide personalized content.
            </p>
          </div>
          <div className="flex items-center gap-2 self-end sm:self-center">
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleDecline}
              className="hover:bg-destructive/10"
            >
              Decline
            </Button>
            <Button 
              size="sm" 
              onClick={handleAccept}
              className="bg-blog-neon hover:bg-blog-neon-dark"
            >
              Accept
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-8 w-8" 
              onClick={handleDecline}
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
